import Vue from 'vue';
import VueRouter from 'vue-router';


Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () =>
      import ("../views/Home/index.vue"),
  },
  {
    path: '/Product',
    name: 'Product',
    component: () =>
      import ("../views/Product/index.vue"),
  },
  {
    path: '/About',
    name: 'About',
    component: () =>
      import ("../views/About/index.vue"),
  }
];

const router = new VueRouter({
  mode: 'hash',
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 如果存在 savedPosition，则使用它（例如浏览器的前进/后退按钮）
    if (savedPosition) {
      return savedPosition;
    } else {
      // 否则滚动到顶部
      return { x: 0, y: 0 };
    }
  }
});

export default router;